<template>
  <div class="home" data-cy="listOfReports">
    <h1 class="greeting" v-if="$vuetify.breakpoint.mdAndUp">
      {{txt.welcome}}
    </h1>

    <v-container>
      <v-row>
		<!-- Registration system -->
		<home-card
			:cardTitle="txt.cardTitle.registrationReport"
			:description="txt.description.registrationReport"
			:reportLink="route.registrationReport"
			:render="reports.regsys"
		/>
        <!-- Guest card report -->
		<home-card
			:cardTitle="txt.cardTitle.guestcard"
			:description="txt.description.guestcard"
			:reportLink="route.guestcard"
			:render="reports.guestcard"
		/>
        <!-- Revenue report -->
		<home-card
			:cardTitle="txt.cardTitle.revenue"
			:description="txt.description.revenue"
			:reportLink="route.revenue"
			:render="reports.revenue"
		/>
        <!-- Participant report -->
		<home-card
			:cardTitle="txt.cardTitle.participant"
			:description="txt.description.participant"
			:reportLink="route.participant"
			:render="reports.participant"
		/>
		<!-- Statistic report -->
		<home-card
			:cardTitle="txt.cardTitle.statistics"
			:description="txt.description.statistics"
			:reportLink="route.statistics"
			:render="reports.statistics"
		/>
        <!-- Validity Checker -->
        <home-card
			:cardTitle="txt.cardTitle.validityChecker"
			:description="txt.description.validityChecker"
			:reportLink="route.validityChecker"
			:render="reports.validityChecker"
        />
        <!-- Admin page -->
		<home-card
			:cardTitle="txt.cardTitle.admin"
			:description="txt.description.admin"
			:reportLink="route.admin"
			:render="reports.admin"
		/>
		<!-- revenue sum report -->
		<home-card
			:cardTitle="txt.cardTitle.revenueSumReport"
			:description="txt.description.revenueSumReport"
			:reportLink="route.revenueSumReport"
			:render="reports.revenueSumReport"
		/>
		<!-- user manager -->
		<home-card
			:cardTitle="txt.cardTitle.userManager"
			:description="txt.description.userManager"
			:reportLink="route.userManager"
			:render="reports.userManager"
		/>
		<!-- Parking App Zillertal -->
		<home-card
			:cardTitle="txt.cardTitle.parking"
			:description="txt.description.parking"
			:reportLink="route.parking"
			:render="reports.parking"
		/>
		<!-- Coupon Code Report -->
		<home-card
			:cardTitle="txt.cardTitle.couponcode"
			:description="txt.description.couponcode"
			:reportLink="route.couponcode"
			:render="reports.couponcode"
		/>
		<!-- Billing Engine Payment Report -->
		<home-card
			:cardTitle="txt.cardTitle.billingEngine"
			:description="txt.description.billingEngine"
			:reportLink="route.billingEngine"
			:render="reports.billingEngine"
		/>
		</v-row>
	</v-container>
	</div>
</template>

<script>
import axios from 'axios'
import HomeCard from '../components/arcCustom/homeCard.vue'

export default {
	name: 'ArcHome',
	components: {
		HomeCard,
	},
	data() {
		return {
			cardCount: '',
			alignments: ['start', 'center', 'end'],
			route: {
				validityChecker: 'validitychecker',
				registrationReport: 'registrationReport',
				guestcard: 'guestcard',
				revenue: 'revenuereport',
				admin: 'admin',
				participant: 'participant',
				statistics: 'statistics',
				revenueSumReport: 'revenuesumreport',
				userManager: 'usermanager',
				parking: 'parking',
				couponcode: 'couponCodeReport',
				billingEngine: 'billingengine',
			},
			txt: {
				cardTitle: {
					validityChecker: 'Access Transaction Report',
					registrationReport: 'Registration report',
					guestcard: 'Guest card',
					revenue: 'Revenue detail report',
					admin: 'Administration',
					participant: 'Participant report',
					statistics: 'Statistic XML exports',
					revenueSumReport: 'Revenue Sum Report',
					userManager: 'Keycloak User Manager',
					parking: 'Parking Permission',
					couponcode: 'Coupon Code Report',
					billingEngine: 'Billing Engine Payment Report',
				},
				description: {
					validityChecker: 'Redemptions of Validity Checker App or Alturos TicketService',
					registrationReport: 'Overnight stays á age group, residence tax, accommodation fee',
					guestcard: 'Issued guest cards, guestcard name, counts',
					revenue: 'Sold items, counts, amounts',
					admin: 'Admin tools',
					participant: 'Participant Report',
					statistics: 'BAFS and TOUROBS XML exports',
					revenueSumReport: 'Internal report for revenue overview of installations',
					userManager: 'Grant or revoke access to reports, create, edit and delete users',
					parking: 'Zillertal Parking Permission App',
					couponcode: 'Provides summary of issued coupons, discounts given',
					billingEngine: 'List of billing engine payments',
				},
				home: 'Home',
				approvedReports: '',
				logout: 'Logout',
				welcome: 'Welcome to the report center!',
			},
			reports: {
				regsys: false,
				guestcard: false,
				revenue: false,
				admin: false,
				participant: false,
				statistics: false,
				validityChecker: false,
				revenueSumReport: false,
				userManager: false,
				parking: false,
				couponcode: false,
				billingEngine: false,
			},
			lang: '',
		}
	},
	methods: {
		changeLocale() {
			if (this.$vuetify.lang.current === 'de') {
				this.$vuetify.lang.current = 'en'
			} else {
				this.$vuetify.lang.current = 'de'
			}
		},
		getApprovedReports() {
			axios
				// eslint-disable-next-line no-undef
				.get(`${config.baseAPIurl}/index/approved-reports`)
				.then(r => {
					// registration system report
					if (r.data.permittedReports.includes('rs')) {
						this.$data.reports.regsys = true
						this.cardCount += 1
					}
					// guestcard report
					if (r.data.permittedReports.includes('gc')) {
						this.$data.reports.guestcard = true
					}
					// revenue report
					if (r.data.permittedReports.includes('rr')) {
						this.$data.reports.revenue = true
					}
					// participant report visualized
					if (r.data.permittedReports.includes('pt')) {
						this.$data.reports.participant = true
					}
					// admin page
					if (r.data.permittedReports.includes('admin')) {
						this.$data.reports.admin = true
					}
					// statistic aletsch arena reports
					if (r.data.permittedReports.includes('aastat')) {
						this.$data.reports.statistics = true
					}
					// validity checker
					if (r.data.permittedReports.includes('vc')) {
						this.$data.reports.validityChecker = true
					}
					// revenue sum report
					if (r.data.permittedReports.includes('rsr')) {
						this.$data.reports.revenueSumReport = true
					}
					// user manager
					if (r.data.permittedReports.includes('user')) {
						this.$data.reports.userManager = true
					}
					// parking app for zillertal
					if (r.data.permittedReports.includes('parking')) {
						this.$data.reports.parking = true
					}
					// coupon code report
					if (r.data.permittedReports.includes('cc')) {
						this.$data.reports.couponcode = true
					}
					// coupon code report
					if (r.data.permittedReports.includes('be')) {
						this.$data.reports.billingEngine = true
					}
					this.$data.approvedReports = r.data.permittedReports
					this.$data.approvedRoles = r.data.permittedRoles
				})
				.catch((e) => {
					console.log(e)
				})
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getApprovedReports()
		})
	},
}
</script>

<style>
.logo {
  height: 50%;
  width: 30%;
}

.greeting {
  padding-top: 20px;
  padding-bottom: 50px;
}

.col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col-auto,
.col-lg,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-1,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-auto {
  width: 100%;
  padding: 12px;
}
</style>
